var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDropsOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 248,
    viewBox: "0 0 304 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4339 68.9999C34.4339 31.0304 68.3743 0.25 110.242 0.25H227.744C269.612 0.25 303.552 31.0304 303.552 69V179C303.552 216.97 269.612 247.75 227.744 247.75H15.4819C9.91011 247.75 4.78723 244.978 2.14034 240.532C-0.506547 236.085 -0.250908 230.681 2.80611 226.456L26.9766 193.054C31.8419 186.33 34.4339 178.464 34.4339 170.422V68.9999ZM110.242 27.75C85.1213 27.75 64.7571 46.2182 64.7571 68.9999V170.422C64.7571 183.825 60.437 196.936 52.3283 208.142L43.5666 220.25H227.744C252.865 220.25 273.229 201.782 273.229 179V69C273.229 46.2183 252.865 27.75 227.744 27.75H110.242Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.259 124C182.259 131.594 175.471 137.75 167.097 137.75C158.724 137.75 151.935 131.594 151.935 124C151.935 116.406 158.724 110.25 167.097 110.25C175.471 110.25 182.259 116.406 182.259 124Z",
    fill: "#FF9900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.905 124C242.905 131.594 236.117 137.75 227.743 137.75C219.37 137.75 212.582 131.594 212.582 124C212.582 116.406 219.37 110.25 227.743 110.25C236.117 110.25 242.905 116.406 242.905 124Z",
    fill: "#FF9900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.612 124C121.612 131.594 114.824 137.75 106.451 137.75C98.0771 137.75 91.2891 131.594 91.2891 124C91.2891 116.406 98.0771 110.25 106.451 110.25C114.824 110.25 121.612 116.406 121.612 124Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDropsOrange);
export default __webpack_public_path__ + "static/media/three-drops-orange.a6a33d3531a29704da68deb9845fcf46.svg";
export { ForwardRef as ReactComponent };